module.exports = __webpack_public_path__ + "static/media/clock.12dda63f.png";